// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__Efu7b","intIcon":"intIcon__3BVu5"};


//////////////////
// WEBPACK FOOTER
// ./components/gemView/scss/gemView.scss
// module id = hJ0q
// module chunks = 0